// client/src/constants/availabilityMessages.js

/**
 * Centralized informational messages about availability system
 * Following SRP: Separated UI text from component logic
 */

export const AVAILABILITY_INFO = {
  HEADING: 'How Availability Works',

  DESCRIPTION: `Setting availability means you're open to receiving match proposals at these times. When opponents see your availability, they can send you a proposal — you'll still have the chance to accept or decline before the match is scheduled.`,

  ENCOURAGEMENT: `Feel free to add availability without hesitation — it gives you flexibility! 🎾`,

  // Compact version for modals (space-constrained contexts)
  COMPACT_DESCRIPTION: `You're showing when you're open to play. Opponents can propose matches — you'll accept or decline each one.`,

  // Short version for inline explanations
  SHORT_DESCRIPTION: 'receive proposals, not auto-schedule',
}
